export interface IPhoneNumbers {
  e164Number: string;
  isTollFree: boolean;
  state: string;
  city: string;
  setupCost: number;
  mrc: number;
  purchaseDate: string;
  provisioningStatus: ProvisioningStatus;
  lastMRCDate: string;
}

export enum ProvisioningStatus {
  Provisioning = "provisioning",
  Completed = "completed",
  Error = "error",
  Deleted = "deleted",
  Assigned = "assigned",
}

export interface IAivrApps {
  aivrAppId: string;
  accountId: string;
  contextId: string;
  name: string;
  logic: IAivrLogic[];
  voice: string;
  jwt: string;
  mainDnis: string;
  secondaryDnisList: string[];
  voiceConnectorId: string;
  vcOutboundHostName: string;
  recordCalls: boolean;
  percentCallsToTranscribe: number;
  csidInCallback: CsidInCallback;
  sipUriUsername: string;
  saConfig: string;
}

export enum CsidInCallback {
  Path = "path",
  Query = "query",
  Body = "body",
}

export interface IAivrLogic {
  type: AivrLogicType | string;
  media: AivrLogicMedia | string;
  callbackUrl?: string;
  userAppData?: string;
}

export enum AivrLogicType {
  Inbound = "inbound",
  Queue = "queue",
  Unavailable = "unavailable",
  Callback = "callback",
}

export enum AivrLogicMedia {
  Speech = "speech",
  Web = "web",
}

export enum UserPermission {
  Administrator = "admin",
  Billing = "billing",
  Greg = "greg",
  CMP = "cmp",
  User = "user",
}

export interface IUserPermissions {
  [UserPermission.Administrator]: boolean;
  [UserPermission.Billing]: boolean;
  [UserPermission.Greg]: boolean;
  [UserPermission.CMP]: boolean;
}

export interface IContext {
  id: string;
  name: string;
}

export interface IAccountPhoneNumbersCols {
  number?: boolean;
  location?: boolean;
  status?: boolean;
  setupCost?: boolean;
  monthlyCost?: boolean;
  context?: boolean;
  apps?: boolean;
  delete?: boolean;
  tollFree?: boolean;
  purchaseDate?: boolean;
  lastBilledDate?: boolean;
  lastMrcDate?: boolean;
}
